import {
  mapRangeVariantToDateRange,
  DATE_RANGES_KEYS,
  type DateRangeVariant,
} from '../DateRangeService/DateRangePickerService';

const LIGHTWEIGHT_FILTERS_DEFAULT_RANGES_LABELS_MAP: Record<DateRangeVariant, string> = {
  today: 'Today',
  yesterday: 'Yesterday',
  last_7_days: 'Last 7 days',
  last_14_days: 'Last 14 days',
  last_30_days: 'Last 30 days',
  this_week: 'This week',
  last_week: 'Last week',
  this_month: 'This month',
  last_month: 'Last month',
  this_quarter: 'This quarter',
  last_quarter: 'Last quarter',
  custom: 'Custom',
};

export const getAllRanges = () => {
  return DATE_RANGES_KEYS.map((rangeVariant) => ({
    type: rangeVariant,
    label: LIGHTWEIGHT_FILTERS_DEFAULT_RANGES_LABELS_MAP[rangeVariant],
    getValue: () => mapRangeVariantToDateRange(rangeVariant),
  }));
};
